import { useEffect, useState } from 'react';
import { type Control, useWatch } from 'react-hook-form';

import type { TIeForm } from '@/components/App/Leasing/types';
import { DictTypes } from '@/constants';
import { useAppSelector } from '@/store';

import {
  NOT_REQUIRED_FIELDS,
  REQUIRED_FIELDS,
  stepCountItemsData
} from '../constants';

interface IProps {
  control: Control<TIeForm>;
}

const useStepCount = ({ control }: IProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const [stepCountItems, setStepCountItems] = useState(stepCountItemsData);

  const [socialStatus, proofInCome] = useWatch({
    control,
    name: ['socialStatus', 'proofInCome']
  });

  const firstStepWatchValues = useWatch({
    control,
    name: REQUIRED_FIELDS[0].concat(NOT_REQUIRED_FIELDS[0])
  });
  const firstStepValues = firstStepWatchValues.filter((item) => {
    if (typeof item === 'object' && item && 'brand' in item)
      return Boolean(item.brand);
    else return Boolean(item);
  }).length;

  const secondStepValues = useWatch({
    control,
    name: REQUIRED_FIELDS[1].concat(NOT_REQUIRED_FIELDS[1])
  }).filter(Boolean).length;

  const thirdStepWatchValues = useWatch({
    control,
    name: REQUIRED_FIELDS[2].concat(NOT_REQUIRED_FIELDS[2])
  });
  const thirdStepValues = thirdStepWatchValues.filter((item) => {
    if (typeof item === 'object' && item && 'uuid' in item)
      return Boolean(item.uuid);
    else return Boolean(item);
  }).length;

  useEffect(() => {
    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[0].validFields = firstStepValues;
    setStepCountItems(newStepCountItems);
  }, [firstStepValues]);

  useEffect(() => {
    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[1].validFields = secondStepValues;
    setStepCountItems(newStepCountItems);
  }, [secondStepValues]);

  useEffect(() => {
    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[2].validFields = thirdStepValues;
    setStepCountItems(newStepCountItems);
  }, [thirdStepValues]);

  // Добавляем к максимальному количество полей 3 шага, в зависимости от ослувий
  useEffect(() => {
    if (!dicts) return;
    const servicemanClient =
      dicts[DictTypes.SocialStatuses]?.getBy.code[Number(socialStatus)]
        ?.name === 'Военнослужащий'
        ? 0
        : 1;

    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[2].totalFields =
      REQUIRED_FIELDS[2].length - servicemanClient - (proofInCome ? 0 : 1);

    setStepCountItems(newStepCountItems);
  }, [socialStatus, proofInCome, dicts]);

  return { stepCountItems };
};

export default useStepCount;
